/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsDigitizingPositionListItem
 */
export interface DigitizingMelcoDigitizingModelsDigitizingPositionListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingPositionListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingPositionListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingPositionListItem
     */
    icon_link?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingPositionListItem
     */
    sort_order?: number;
}

export function DigitizingMelcoDigitizingModelsDigitizingPositionListItemFromJSON(json: any): DigitizingMelcoDigitizingModelsDigitizingPositionListItem {
    return DigitizingMelcoDigitizingModelsDigitizingPositionListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsDigitizingPositionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsDigitizingPositionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'icon_link': !exists(json, 'icon_link') ? undefined : json['icon_link'],
        'sort_order': !exists(json, 'sort_order') ? undefined : json['sort_order'],
    };
}

export function DigitizingMelcoDigitizingModelsDigitizingPositionListItemToJSON(value?: DigitizingMelcoDigitizingModelsDigitizingPositionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'icon_link': value.icon_link,
        'sort_order': value.sort_order,
    };
}


